import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useToggleModal } from '@hooks';
import { useFormContext } from 'react-hook-form';
import { ButtonV2 } from 'components/common/ui';
import {
  ModalFooter,
  ModalFormSection,
  ModalV2,
} from 'components/common/modals';
import { FieldV2 } from 'components/common/form-controls';
import { FileDropZone } from 'components/common/media';
import { procurementServices } from '@services';
import { showError } from '@utils';
import { PROCUREMENT_ORDER_DOCUMENTS_TYPES } from '../constants';

import styles from './procurementOrderContent.style';

const AddDocumentsModal = ({ orderId, index, onGetDocuments, disabled }) => {
  const methods = useFormContext();
  const skuGroupId = methods.watch(`skuGroups.${index}.vehicleDetails.skuId`);
  const { isOpen, handleClose, handleOpen } = useToggleModal();

  const [documents, setDocuments] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const docType = methods.watch('docType');

  const handleDocuments = (files) => {
    setDocuments([...files]);
  };

  const handleCloseModal = () => {
    handleClose();
    setDocuments([]);
    methods.resetField('documents');
    methods.resetField('docType');
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);

      const fd = new FormData();
      const files = Object.values(documents);

      fd.append('type', docType);
      files?.forEach((file) => {
        fd.append('documents', file);
      });

      await procurementServices.addSkuGroupDocument(orderId, skuGroupId, fd);

      await onGetDocuments();
      handleCloseModal();
    } catch (error) {
      showError(error);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (isOpen && !methods.getValues('docType')) {
      methods.setValue('docType', PROCUREMENT_ORDER_DOCUMENTS_TYPES[0].value);
      setDocuments([]);
    }
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <ButtonV2
        color="primary"
        onClick={handleOpen}
        size="small"
        disabled={disabled || submitting}
      >
        + Add
      </ButtonV2>
      <ModalV2
        id="add-documents-modal"
        title="Add Documents"
        isOpen={isOpen}
        onClose={handleCloseModal}
        size="md"
        maxWidth="md"
      >
        <ModalFormSection>
          <Box>
            <FieldV2
              label="Document Type:"
              name="docType"
              type="dropdown"
              control={methods.control}
              options={PROCUREMENT_ORDER_DOCUMENTS_TYPES}
            />
            <FileDropZone
              callBack={handleDocuments}
              currentFiles={documents}
              accept={{
                'image/png': ['.png'],
                'image/jpg': ['.jpg'],
                'image/jpeg': ['.jpeg'],
                'application/pdf': ['.pdf'],
              }}
              styles={styles}
            />
          </Box>
        </ModalFormSection>
        <ModalFooter>
          <ButtonV2
            type="button"
            variant="outlined"
            onClick={handleCloseModal}
            disabled={submitting}
          >
            Cancel
          </ButtonV2>
          <ButtonV2
            disabled={documents.length === 0 || submitting}
            onClick={handleSubmit}
          >
            Add
          </ButtonV2>
        </ModalFooter>
      </ModalV2>
    </Box>
  );
};

export default AddDocumentsModal;
